import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { Switch } from '@rsos/components/capstone/base';
import { selectCapstoneAudioSettingsForFeature } from '@rsos/sinatra/src/selectors/selectAudioSettings';
import useIsIRP from '@rsos/utils/useIsIRP';
import { AdminDispatch } from '../../../../app/store';
import { usePatchAudioSettings } from '../../app/patchAudioSettings';
import SoundSelect from '../SoundSelect';
import {
  trackToggleSoundOnOff,
  trackToggleRepeatAlertSound,
} from '../audioSettingsTrackings';
import styles from '../settings.module.css';

export const DigitalAlertsAudioSettings = () => {
  const dispatch = useDispatch<AdminDispatch>();
  const alerts = useSelector(selectCapstoneAudioSettingsForFeature('alerts'));

  const { repeat: isRepeatOn, sound_on: isSoundOn, tone } = alerts;

  const patchAudioSettings = usePatchAudioSettings('alerts');
  const updateAudioSettings = (update: Partial<typeof alerts>) => {
    dispatch(patchAudioSettings(update));
  };

  const { irpVersion } = useIsIRP();
  const toggleSoundOn = () => {
    updateAudioSettings({ sound_on: !isSoundOn });
    trackToggleSoundOnOff(irpVersion, isSoundOn, 'alerts');
  };
  const toggleRepeatSound = () => {
    updateAudioSettings({ repeat: !isRepeatOn });
    trackToggleRepeatAlertSound(irpVersion, isRepeatOn);
  };

  return (
    <div className={styles.card}>
      <div>
        <div className={styles.cardTitle}>Alerts</div>
        <div className={styles.cardDescription}>
          Notify your agents with sound when new alerts appear in the queue.
        </div>
      </div>
      <div className={styles.soundBlock}>
        <span>Sound Notification</span>
        <Switch onOffLabel onClick={toggleSoundOn} isOn={isSoundOn} />
      </div>
      <SoundSelect
        isSoundOn={isSoundOn}
        type={'alerts'}
        tone={tone}
        updateAudioSettings={updateAudioSettings}
      />
      <span>
        The sound will repeat until the new alert is accepted or declined.
        <span style={{ color: 'var(--text-color-heavy-warning' }}>
          This applies to agencies using Digital Alerts only.
        </span>
      </span>
      <div className={cn(styles.soundBlock, { [styles.disabled]: !isSoundOn })}>
        <span>Repeat Sound</span>
        <Switch
          onOffLabel
          disabled={!isSoundOn}
          onClick={toggleRepeatSound}
          isOn={isRepeatOn}
        />
      </div>
    </div>
  );
};
